import React from 'react';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Container } from '@si-armes/dsfr-react';
import ModifierArmeElementsArme from 'components/arme/ModifierArmeElementsArme';
import ErreurPossession from './erreur-possession/ErreurPossession';

const SignalerErreurEtape2 = ({
    signalerArmeData,
    etapeSuivante,
    etapePrecedente,
    handleUpdateSignalerArmeData,
}) => {
    const { data: arme } = useSelector((state) => state.armes.recuperer);

    return (
        <Container fluid={false}>
            {signalerArmeData.typeErreur === 'non-possession' ? (
                <ErreurPossession
                    signalerArmeData={signalerArmeData}
                    etapeSuivante={etapeSuivante}
                    etapePrecedente={etapePrecedente}
                    handleUpdateSignalerArmeData={handleUpdateSignalerArmeData}
                />
            ) : null}
            {signalerArmeData.typeErreur === 'information-incorrectes' ? (
                <ModifierArmeElementsArme
                    dataArmeElementsArme={arme}
                    etapePrecedente={etapePrecedente}
                    enregistrerData={handleUpdateSignalerArmeData}
                    etapeSuivante={etapeSuivante}
                    modaleArmeAvant2011={false}
                    recuperationArmeEtElementsExistant
                />
            ) : null}
        </Container>
    );
};

SignalerErreurEtape2.propTypes = {
    etapePrecedente: PropTypes.func.isRequired,
    etapeSuivante: PropTypes.func.isRequired,
    handleUpdateSignalerArmeData: PropTypes.func.isRequired,
    signalerArmeData: PropTypes.shape({
        typeErreur: PropTypes.string.isRequired,
    }).isRequired,
};

export default SignalerErreurEtape2;
